module.exports = __webpack_public_path__ + "img/CAS.0290e0d5.svg";